import Config from '../../config';
import { encodeToBase64, handleErrors, parseAsJson, parseChunksAsJson } from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';

export const fetchCustomReports = async () => await fetch(
  Config.endpoints.FETCH_CUSTOM_REPORTS
)
  .then(handleErrors({ errorMessage: 'Fetching Custom Reports failed' }))
  .then(parseAsJson);

export const fetchEnabledCustomReports = async () => await fetch(
  Config.endpoints.FETCH_ENABLED_CUSTOM_REPORTS
)
  .then(handleErrors({ errorMessage: 'Fetching Custom Reports failed' }))
  .then(parseAsJson);

export const fetchCustomReportSet = async (reportSetId: string) => await fetch(
  Config.endpoints.FETCH_CUSTOM_REPORT_SET
    .replace(/:reportSetId/, reportSetId)
)
  .then(handleErrors({ errorMessage: 'Fetching Custom Report Set failed' }))
  .then(parseAsJson);

export const addCustomReport = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.SAVE_CUSTOM_REPORT,
  {
    method: 'POST',
    body: JSON.stringify(encodeToBase64(customReportData)),
  }
)
  .then(handleErrors({ errorMessage: 'Adding Custom Report failed' }))
  .then(parseAsJson);

export const updateCustomReport = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.UPDATE_CUSTOM_REPORT
    .replace(/:reportSetId/, customReportData.reportSetId),
  {
    method: 'PUT',
    body: JSON.stringify(encodeToBase64(customReportData)),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Custom Report failed' }));

export const updateDisplayFlag = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.UPDATE_CUSTOM_REPORT_DISPLAY_FLAG
    .replace(/:reportSetId/, customReportData.reportSetId),
  {
    method: 'POST',
    body: JSON.stringify({
      reportSetDisplayFlag: customReportData.reportSetDisplayFlag,
      reportSetId: customReportData.reportSetId,
    }),
  }
)
  .then(handleErrors({ errorMessage: 'Updating Custom Report display flag failed' }));

export const deleteCustomReport = async (reportSetId: string) => await fetch(
  Config.endpoints.DELETE_CUSTOM_REPORT
    .replace(/:reportSetId/, reportSetId),
  {
    method: 'DELETE',
  }
)
  .then(handleErrors({ errorMessage: 'Deleting Custom Report failed' }));

export const testCustomReport = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.TEST_CUSTOM_REPORT,
  {
    method: 'POST',
    body: JSON.stringify(encodeToBase64(customReportData)),
  }
)
  .then(handleErrors({
    parseResponseErrorMessage: true,
    errorMessage: 'Testing Custom Report failed',
  }))
  .then(parseAsJson);

export const validateCustomReport = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.RUN_VALIDATE_REPORT,
  {
    method: 'POST',
    body: JSON.stringify(encodeToBase64(customReportData)),
  }
)
  .then(handleErrors({
    parseResponseErrorMessage: true,
    errorMessage: 'Validating Custom Report failed',
  }))
  .then(parseAsJson);


export const runCustomReport = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.RUN_CUSTOM_REPORT,
  {
    method: 'POST',
    body: JSON.stringify(customReportData),
  }
)
  .then(handleErrors({
    parseResponseErrorMessage: true,
    errorMessage: 'Running Custom Reports failed',
  }))
  .then(parseChunksAsJson);

export const getCustomReportSetParams = async (customReportData: Record<string, any>) => await fetch(
  Config.endpoints.FETCH_CUSTOM_REPORT_SET_PARAMS
    .replace(/:reportSetId/, customReportData.reportSetId),
  {
    method: 'POST',
    body: JSON.stringify({ paramValues: customReportData.paramValues }),
  }
)
  .then(handleErrors({ errorMessage: 'Fetching Custom Report Params failed' }))
  .then(parseAsJson);
